import { render, staticRenderFns } from "./OverdueBrokers.vue?vue&type=template&id=1baa8765"
import script from "./OverdueBrokers.vue?vue&type=script&lang=js"
export * from "./OverdueBrokers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports